import { useAuthStore } from "../store/auth.store";
import { useBreadcrumbsStore } from "../store/breadcrumbs.store";
import { useEffect, useState } from "react";
import { useTranslation } from "../hooks/useTranslation";
import { useUnregisteredFTNStore } from "../store/unregisteredFTN.store";
import { useUnregisteredFTN } from "../hook/partner/unregisteredFTN.partner.hook";
import { NavLink } from "react-router";
import { Accordion } from "react-bootstrap";

function FortinetUnregisteredLicenses() {
  const { t } = useTranslation();
  const token = useAuthStore((state) => state.token);

  const setBreadcrumbs = useBreadcrumbsStore((state) => state.setBreadcrumbs);
  const setPagename = useBreadcrumbsStore((state) => state.setPagename);
  useEffect(() => {
    setPagename(t("fortinet.unregisteredLicenses"));
    setBreadcrumbs([{ link: "/fortinet", name: "Fortinet" }]);
  }, [t]);

  const licensesMutation = useUnregisteredFTN();
  const licences = useUnregisteredFTNStore((state) => state.licenses);

  useEffect(() => {
    if (token) {
      licensesMutation.mutate({
        token,
      });
    }
  }, [token]);

  if (licensesMutation.isLoading) {
    return <div className="alert alert-info">{t("common.uploadingData")}...</div>;
  }

  if (licences && licences.length === 0) {
    return (
      <div className="alert alert-success">
        {t("fortinet.noLicenses")}
      </div>
    );
  } else {
    return (
      <>
        <div className="card">
          <div className="card-body">
            <Accordion>
              {licences?.map((opportunity) => (
                <Accordion.Item
                  key={opportunity.opportunity_id}
                  eventKey={opportunity.opportunity_id}
                >
                  <Accordion.Header>
                    PŘ{opportunity.opportunity_id}: {opportunity.description}
                    <strong className="ms-5">
                      {opportunity.end_customer?.name}
                    </strong>
                  </Accordion.Header>
                  <Accordion.Body>
                    <h3>
                      <NavLink
                        to={"/prilezitost/" + opportunity.opportunity_id}
                      >
                        PŘ{opportunity.opportunity_id}:{" "}
                        {opportunity.description}
                      </NavLink>
                    </h3>
                    <div className="mb-3">{opportunity.end_customer?.name}</div>
                    <table className="table align-middle table-row-dashed fs-6 gy-5 dataTable">
                      <thead>
                        <tr className="text-start fw-bold fs-7 text-uppercase gs-0">
                          <th>Contract number</th>
                          <th>{t("common.sn")}</th>
                          <th>SKU</th>
                          <th>{t("fortinet.creationDate")}</th>
                          <th>{t("fortinet.autoRegistrationDate")}</th>
                          <th>{t("fortinet.autoRegistered")}</th>
                          <th>{t("fortinet.lastUpdate")}</th>
                        </tr>
                      </thead>
                      <tbody className="fw-semibold text-gray-600">
                        {opportunity.licenses?.map((license, lindex) => (
                          <tr key={lindex}>
                            <td>{license.contract_number}</td>
                            <td>{license.serial_number}</td>
                            <td>{license.sku}</td>
                            <td className="text-center">
                              {new Date(
                                license.creation_date
                              ).toLocaleDateString()}
                            </td>
                            <td className="text-center">
                              {license.autostart_date ? (
                                new Date(
                                  license.autostart_date
                                ).toLocaleDateString()
                              ) : (
                                <span className="badge badge-success">
                                  {t("fortinet.notRegistered")}
                                </span>
                              )}
                            </td>
                            <td className="text-center">
                              {license.autostarted ? (
                                <span className="badge badge-success">{t("common.yes")}</span>
                              ) : (
                                <span className="badge badge-danger">{t("common.no")}</span>
                              )}
                            </td>
                            <td>
                              {new Date(license.last_update).toLocaleString()}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        </div>
      </>
    );
  }
}

export default FortinetUnregisteredLicenses;
